import { Link } from '@remix-run/react';
import { useVitePostHog } from 'vite-plugin-posthog/react';
import AnnouncementBar from '~/components/LandingPage/AnnouncementBar';
import Navigation from '~/components/LandingPage/Navigation';

const Hero = () => {
	// PostHog
	const posthog = useVitePostHog();

	const openShopifyAffiliate = () => {
		posthog?.capture('shopify_affiliate', {
			source: 'landingpage',
		});

		window.open('https://store.pagepilot.ai/?ref=pphp', '_blank');
	};

	return (
		<>
			<AnnouncementBar />

			<section
				id="section1"
				className="max-w-8xl align-center relative mx-auto flex flex-col justify-center pb-4 pt-10 sm:pt-16 xl:pt-24 ">
				<img
					src="/images/landingpage/heroLight.svg"
					className="absolute left-0 right-0 top-0 z-0 mx-auto opacity-60"
					width="500"
					height="500"
					alt="Lights"
				/>

				<div className="relative mx-auto px-6 lg:px-8 xl:px-20">
					<Navigation />

					<div className="rising-stars rising-stars-visible opacity-60">
						<div className="h-[1px] w-[1px]"></div>
						<div className="h-[1px] w-[1px]"></div>
						<div className="h-[1px] w-[1px]"></div>
					</div>

					<div className="relative mx-auto flex flex-col items-center justify-center pt-0 md:max-w-2xl lg:max-w-7xl lg:space-y-8 lg:pt-12">
						<img
							src="/images/landingpage/heroRocket.webp"
							className="animate-smoothMove absolute -bottom-10 -left-40 z-0 max-w-[400px] -rotate-[0deg] opacity-20 xl:opacity-100"
							alt="PagePilot.ai Rocket"
							width="400"
							height="400"
						/>

						<img
							src="/images/landingpage/heroSphere.webp"
							className="animate-smoothMove absolute -bottom-[250px] -right-[150px] z-0 hidden max-w-[400px] opacity-20 blur-sm sm:flex xl:opacity-100"
							alt="PagePilot.ai Sphere"
							width="400"
							height="400"
						/>
						<div className="relative z-10 flex flex-col">
							<div className="flex  flex-row flex-wrap items-center justify-center pb-2">
								<div className="flex flex-wrap items-center justify-center gap-1 text-sm font-light text-white lg:gap-3 lg:text-lg">
									<div className="flex lg:hidden">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 20 20"
											fill="currentColor"
											className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
											<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
										</svg>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 20 20"
											fill="currentColor"
											className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
											<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
										</svg>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 20 20"
											fill="currentColor"
											className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
											<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
										</svg>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 20 20"
											fill="currentColor"
											className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
											<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
										</svg>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 20 20"
											fill="currentColor"
											className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
											<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
										</svg>
									</div>
									<div>
										<span className="hidden lg:inline-flex">Rated</span> "Excellent"{' '}
										<span className="font-bold">4.8/5</span>
									</div>
									<div className="hidden flex-row lg:flex">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 20 20"
											fill="currentColor"
											className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
											<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
										</svg>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 20 20"
											fill="currentColor"
											className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
											<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
										</svg>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 20 20"
											fill="currentColor"
											className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
											<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
										</svg>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 20 20"
											fill="currentColor"
											className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
											<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
										</svg>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 20 20"
											fill="currentColor"
											className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
											<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
										</svg>
									</div>
									by our <span className="font-bold">1000+</span> successful dropshippers
								</div>
							</div>
							<div className="relative flex max-w-[425px] flex-row flex-col items-center justify-center pb-4 text-center sm:max-w-[700px] lg:max-w-6xl lg:pb-0">
								<h1 className="text-transparent bg-clip-text text-3xl font-extrabold leading-[40px] sm:text-5xl sm:leading-[55px] lg:text-6xl lg:leading-[80px] 2xl:text-7xl">
									<span className="bg-gradient-to-b from-white from-70% to-[#b2b2b2] bg-clip-text">
										Instantly Boost Your Sales with{' '}
									</span>
									<span className="bg-gradient-to-b from-white from-30% to-[#7496F8] bg-clip-text">
										High-Converting Product Pages{' '}
									</span>
									<span className="bg-gradient-to-b from-white from-70% to-[#b2b2b2] bg-clip-text">in Seconds </span>
								</h1>
							</div>
						</div>

						<div className="max-w-3xl pb-4 text-center text-lg !leading-8 text-white lg:pb-0 lg:text-xl">
							Effortlessly <span className="underline underline-offset-[6px]">Test Multiple Products</span> and Outpace
							Your Competition with PagePilot's AI. Save Time, Cut Costs, and Maximize Profits.
						</div>

						<div className="relative w-full overflow-hidden rounded-2xl p-[1px] sm:max-w-[400px]">
							<div className="absolute inset-0 z-10 h-full w-full animate-rotate rounded-lg bg-[conic-gradient(#6756ff_20deg,transparent_120deg)]"></div>
							<div className="relative z-20 flex w-full flex-col items-center justify-center gap-6 rounded-2xl border-4 border-black lg:flex-row lg:gap-10 lg:pt-0">
								<Link
									prefetch="intent"
									className="btn-landing flex w-full max-w-full flex-col text-center font-semibold"
									to="/signup">
									<div>Start Your Free Trial Now</div>
								</Link>
							</div>
						</div>

						<div className="relative z-20 !mt-[14px] flex">
							<div
								className="flex flex-wrap items-center justify-center gap-2 text-green-200 hover:cursor-pointer sm:gap-0"
								onClick={openShopifyAffiliate}>
								<span className="text-xs md:text-sm">Don't have a Shopify Store?</span>
								<span className="mx-2 hidden text-lg text-green-200 opacity-50 sm:flex">|</span>
								<span className="text-xs underline underline-offset-8 md:text-sm">
									Create one using our AI Store Builder in less than 10 minutes
								</span>
							</div>
						</div>

						<div className="mx-auto mt-4 flex w-full max-w-[600px] flex-col items-center justify-center rounded-2xl px-4 pb-4 lg:gap-2">
							<div className="flex pb-2 pt-2 lg:pb-0 lg:pt-4">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 20 20"
									fill="currentColor"
									className="h-5 w-5 text-[#FFA132]">
									<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
								</svg>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 20 20"
									fill="currentColor"
									className="h-5 w-5 text-[#FFA132]">
									<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
								</svg>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 20 20"
									fill="currentColor"
									className="h-5 w-5 text-[#FFA132]">
									<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
								</svg>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 20 20"
									fill="currentColor"
									className="h-5 w-5 text-[#FFA132]">
									<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
								</svg>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 20 20"
									fill="currentColor"
									className="h-5 w-5 text-[#FFA132]">
									<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
								</svg>
							</div>
							<p className="max-w-lg pb-2 text-center text-sm text-white md:text-base/7 lg:pb-0">
								"PagePilot.ai transformed my business! My sales skyrocketed with its high-converting pages. This tool is
								a must-have for any dropshipper."
							</p>
							<p className="text-center text-base text-gray-DEFAULT-400">Anthony Eclipse</p>
						</div>
					</div>
				</div>
			</section>

			<div className="relative mx-auto max-w-7xl px-6 pb-4 lg:px-16">
				<img
					src="/images/landingpage/heroCone2.webp"
					className="animate-smoothMove absolute -bottom-[150px] -left-[150px] z-20 max-w-[300px] opacity-40 blur-lg xl:opacity-100"
					alt="PagePilot.ai Cone"
					width="300"
					height="300"
				/>

				<div className="relative overflow-hidden rounded-3xl ">
					<div className="to-transparent absolute bottom-0 left-0 right-0 hidden h-[250px] w-full bg-gradient-to-t from-[#272943] via-[#272943]/70 lg:flex" />

					<video
						className="m-auto h-auto w-full"
						loop
						autoPlay
						muted
						playsInline
						preload="metadata"
						title="PagePilot.ai Dropshipping Product Page Generation Demo"
						aria-label="How PagePilot.ai works?">
						<source src="https://cdn.shopify.com/videos/c/o/v/12a7f831d44f4b548d0a6b45839f743d.mp4" type="video/mp4" />
						Your browser does not support our product page generation demo video.
					</video>
				</div>
			</div>
		</>
	);
};

export default Hero;
